let reporting = false;
const originalConsoleError = console.error.bind(console);
const originalConsoleWarn = console.warn.bind(console);

function getLogUrl() {
  const base = import.meta.env.VITE_API_BASE_URL || "/api";
  return `${base.replace(/\/$/, "")}/client-logs`;
}

function normalisePart(part) {
  if (part instanceof Error) {
    return {
      message: part.message,
      stack: part.stack,
      name: part.name,
    };
  }

  if (typeof part === "string") {
    return part;
  }

  try {
    return JSON.stringify(part);
  } catch {
    return String(part);
  }
}

function messageFrom(parts) {
  return parts.map((part) => {
    const normalised = normalisePart(part);
    return typeof normalised === "string"
      ? normalised
      : `${normalised.name || "Error"}: ${normalised.message || ""}`;
  }).join(" ");
}

function stackFrom(parts) {
  const error = parts.find((part) => part instanceof Error);
  return error?.stack;
}

export function logClientError(level, source, ...parts) {
  if (reporting) return;

  const payload = {
    level,
    source,
    message: messageFrom(parts),
    stack: stackFrom(parts),
    url: window.location.href,
    userAgent: navigator.userAgent,
    context: JSON.stringify({
      origin: window.location.origin,
      referrer: document.referrer,
      visibilityState: document.visibilityState,
    }),
  };

  reporting = true;
  fetch(getLogUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((err) => {
    originalConsoleWarn("Client log upload failed", err);
  }).finally(() => {
    reporting = false;
  });
}

export function installClientLogger() {
  window.addEventListener("error", (event) => {
    logClientError("error", "window.error", event.error || event.message);
  });

  window.addEventListener("unhandledrejection", (event) => {
    logClientError("error", "window.unhandledrejection", event.reason);
  });

  console.error = (...args) => {
    originalConsoleError(...args);
    logClientError("error", "console.error", ...args);
  };
}
